import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grouper-body-embedded row full-width flex min-height" }
const _hoisted_2 = { class: "col min-height flex" }
const _hoisted_3 = { class: "grouper-body-embedded-content flex min-height full-height full-width" }
const _hoisted_4 = { class: "embedded-resource-container full-height column min-height" }

import CodesPane from 'components/codes/CodesPane.vue';
  import SearchEmbedded from 'components/search/SearchPaneCompact.vue';
  import ReferencesEmbedded from 'components/references/ReferencesPaneCompact.vue';
  import ResourcesPane from 'components/resources/ResourcesPane.vue';
  import { useLayoutStore } from 'stores/layout-store';
  import { storeToRefs } from 'pinia';
  import { useGrouperStore } from 'stores/grouper-store';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperBodyEmbedded',
  setup(__props) {

  const { getCodesCount, readOnly } = storeToRefs(useGrouperStore());
  const { selectedTab, resourcesSelected } = storeToRefs(useLayoutStore());


return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_card, { class: "codes-card min-height flex column" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "grouper-body-embedded-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tabs, {
                modelValue: _unref(selectedTab),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedTab) ? (selectedTab).value = $event : null)),
                dense: "",
                "no-caps": "",
                class: "text-grey",
                "active-color": "primary",
                "indicator-color": "primary",
                align: "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tab, {
                    name: "codes",
                    label: `Codes (${_unref(getCodesCount)})`
                  }, null, 8, ["label"]),
                  _createVNode(_component_q_tab, {
                    name: "search",
                    label: "Search",
                    disable: _unref(readOnly)
                  }, null, 8, ["disable"]),
                  _createVNode(_component_q_tab, {
                    name: "references",
                    label: "References",
                    disable: _unref(readOnly)
                  }, null, 8, ["disable"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_q_space),
              _createVNode(_component_q_toggle, {
                class: "io-mfe-ig-toggle",
                modelValue: _unref(resourcesSelected),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(resourcesSelected) ? (resourcesSelected).value = $event : null)),
                "checked-icon": "check",
                disable: _unref(readOnly),
                color: "$iodine-light-primary",
                "unchecked-icon": "clear",
                label: "Resources"
              }, null, 8, ["modelValue", "disable"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createVNode(CodesPane, null, null, 512), [
              [_vShow, _unref(selectedTab) == 'codes']
            ]),
            _withDirectives(_createVNode(SearchEmbedded, null, null, 512), [
              [_vShow, _unref(selectedTab) == 'search']
            ]),
            _withDirectives(_createVNode(ReferencesEmbedded, null, null, 512), [
              [_vShow, _unref(selectedTab) == 'references']
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(ResourcesPane)
    ], 512), [
      [_vShow, _unref(resourcesSelected)]
    ])
  ]))
}
}

})